ele.commonPassword = (function() {
	
	var encodedCommonPasswordList = "fgneg,1234djre,1d2j3r4e,n1o2p3q4,nopq1234,npprff14,ncbyyb13,nfqs1234,onolyba5,oyvax182,puneyvr1,puryfrn1,purfgre1,puevf123,sybevqn1,sbbgonyy1,sebag242,shpxlbh1,tngrjnl2,treznal1,unccl123,unjxrlr1,urngure1,urngure2,uryyb123,vybirlbh1,vybirlbh2,wrsserl1,wbunaan1,wbeqna23,whfgvpr4,zvpunry1,zbagnan3,zhfgnat1,app1701q,app1701r,arjlbex1,aveinan1,cnffj0eq,cnffjbeq1,cnffjbeq12,cnffjbeq123,cubravk1,cbefpur911,djregl12,evpneqb1,evpuneq1,ehfu2112,fpbbgre1,fxvccre1,fghqrag2,gehfgab1,ivaprag1,jvyyvnz1,raq";

	function decodePwList(thisPw) {
		var encodedList = new String("");
		for (let i=0;i<thisPw.length;i++) {
			var thisChar=thisPw.charAt(i);	
			var thisCharCode = thisPw.charCodeAt(i);
			if ( thisCharCode >= 97 && thisCharCode <=109 ) { thisChar=String.fromCharCode(thisCharCode + 13) }
			else if ( thisCharCode >= 110 && thisCharCode <=122 ) { thisChar=String.fromCharCode(thisCharCode - 13) }
			encodedList=encodedList+thisChar;
		}
		return encodedList;
	}
	
	return {
		list: decodePwList(encodedCommonPasswordList),
		contains: function(passwordAttempt) {
			return ele.commonPassword.list.indexOf("\,"+passwordAttempt.toLowerCase()+"\,") >= 0;
		}
	};

})();

